
define(
	'AddGTM.AddGTM.AddGTM'
,   [
	]
,   function (
		
	)
{
	'use strict';

	return  {
		swapElements: function swapElements($elem1, $elem2) {
			var $temp = $('<div>').insertAfter($elem1);

			$elem1.insertAfter($elem2);
			$elem2.insertBefore($temp);

			$temp.remove();
		},
		mountToApp: function mountToApp (container)
		{
			var url = window.location.href;

			if (url.includes('/search')) {
				console.log('URL contains /search');
				var match = url.match(/[?&]display=([^&]*)/);
				var display = match ? decodeURIComponent(match[1]) : null;

				match = url.match(/[?&]order=([^&]*)/);
				var order = match ? decodeURIComponent(match[1]) : null;

				if (display || order) {
					// Parse the URL
					url = new URL(url);
					var params = new URLSearchParams(url.search);

					params.delete('order');
					params.delete('display');
					window.location.href = url.origin + url.pathname + '?' + params.toString();
				}
			}
			// using the 'Layout' component we add a new child view inside the 'Header' existing view 
			// (there will be a DOM element with the HTML attribute data-view="Header.Logo")
			// more documentation of the Extensibility API in
			// https://system.netsuite.com/help/helpcenter/en_US/APIs/SuiteCommerce/Extensibility/Frontend/index.html
			
			
			const script = document.createElement('script');
            script.src = 'https://www.googletagmanager.com/gtag/js?id=AW-1031976561'; // or inline via innerText
            script.async = true;
            document.head.appendChild(script);

			const script2 = document.createElement('script');
			var strScript = "window.dataLayer = window.dataLayer || [];";
			strScript += "function gtag(){dataLayer.push(arguments);}";
			strScript += "gtag('js', new Date());";
			strScript += "gtag('config', 'AW-1031976561');";
			script2.innerHTML = strScript;
			document.head.appendChild(script2);

			// Tawk chatbot - inject before </body> (append to body)
			(function injectTawk() {
				if (typeof document === 'undefined' || !document.body) {
					setTimeout(injectTawk, 50);
					return;
				}
				var tawkScript = document.createElement('script');
				tawkScript.type = 'text/javascript';
				tawkScript.text = "var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();(function(){var s1=document.createElement('script'),s0=document.getElementsByTagName('script')[0];s1.async=true;s1.src='https://embed.tawk.to/69946b4582b4ac1c343408c9/1jhls621e';s1.charset='UTF-8';s1.setAttribute('crossorigin','*');s0.parentNode.insertBefore(s1,s0);})();";
				document.body.appendChild(tawkScript);
			})();

			const link1 = document.createElement('link');
			link1.rel = 'apple-touch-icon';
			link1.sizes = '57x57';
			link1.href = '/img/favicons/apple-icon-57x57.png';
			document.head.appendChild(link1);

			const link2 = document.createElement('link');
			link2.rel = 'apple-touch-icon';
			link2.sizes = '60x60';
			link2.href = '/img/favicons/apple-icon-60x60.png';
			document.head.appendChild(link2);

			const link3 = document.createElement('link');
			link3.rel = 'apple-touch-icon';
			link3.sizes = '72x72';
			link3.href = '/img/favicons/apple-icon-72x72.png';
			document.head.appendChild(link3);

			const link4 = document.createElement('link');
			link4.rel = 'apple-touch-icon';
			link4.sizes = '76x76';
			link4.href = '/img/favicons/apple-icon-76x76.png';
			document.head.appendChild(link4);

			const link5 = document.createElement('link');
			link5.rel = 'apple-touch-icon';
			link5.sizes = '114x114';
			link5.href = '/img/favicons/apple-icon-114x114.png';
			document.head.appendChild(link5);

			const link6 = document.createElement('link');
			link6.rel = 'apple-touch-icon';
			link6.sizes = '120x120';
			link6.href = '/img/favicons/apple-icon-120x120.png';
			document.head.appendChild(link6);

			const link7 = document.createElement('link');
			link7.rel = 'apple-touch-icon';
			link7.sizes = '144x144';
			link7.href = '/img/favicons/apple-icon-144x144.png';
			document.head.appendChild(link7);

			const link8 = document.createElement('link');
			link8.rel = 'apple-touch-icon';
			link8.sizes = '152x152';
			link8.href = '/img/favicons/apple-icon-152x152.png';
			document.head.appendChild(link8);

			const link9 = document.createElement('link');
			link9.rel = 'apple-touch-icon';
			link9.sizes = '180x180';
			link9.href = '/img/favicons/apple-icon-180x180.png';
			document.head.appendChild(link9);

			const link10 = document.createElement('link');
			link10.rel = 'icon';
			link10.type = 'image/png';
			link10.sizes = '192x192';
			link10.href = '/img/favicons/android-icon-192x192.png';
			document.head.appendChild(link10);

			const link11 = document.createElement('link');
			link11.rel = 'icon';
			link11.type = 'image/png';
			link11.sizes = '32x32';
			link11.href = '/img/favicons/favicon-32x32.png';
			document.head.appendChild(link11);

			const link12 = document.createElement('link');
			link12.rel = 'icon';
			link1.type = 'image/png';
			link12.sizes = '96x96';
			link12.href = '/img/favicons/favicon-96x96.png';
			document.head.appendChild(link12);

			const link13 = document.createElement('link');
			link13.rel = 'icon';
			link13.type = 'image/png';
			link13.sizes = '16x16';
			link13.href = '/img/favicons/favicon-16x16.png';
			document.head.appendChild(link13);

			const link14 = document.createElement('link');
			link14.rel = 'manifest';
			link14.href = '/img/favicons/manifest.json';
			document.head.appendChild(link14);

			const meta1 = document.createElement('meta');
			meta1.name = 'msapplication-TileColor';
			meta1.content = '#FFFFFF';
			document.head.appendChild(meta1);

			const meta2 = document.createElement('meta');
			meta2.name = 'msapplication-TileImage';
			meta2.content = '/img/favicons/ms-icon-144x144.png';
			document.head.appendChild(meta2);

			const meta3 = document.createElement('meta');
			meta3.name = 'theme-color';
			meta3.content = '#FFFFFF';
			document.head.appendChild(meta3);

			// var dis = this;
			// $(document).ready(function() {
			// 	var url = window.location.href;
			// 	var match = url.match(/[?&]display=([^&]*)/);
			// 	var param = match ? decodeURIComponent(match[1]) : null;
			// 	if (param == 'multi-add-to-cart') {
			// 		var products = $("div.facets-items-collection-view-row.facets-items-multi-add-collection-view-row");
			// 		console.log('multi-add-to-cart', products.length);
			// 		for (var i = 0; i < products.length - 1; i++) {
			// 			console.log('multi-i', i);
			// 			for (var j = 0; j < products.length - i - 1; j++) {
			// 				if (products.eq(j).find('h2.facets-item-cell-multi-add-title').text() > products.eq(j + 1).find('h2.facets-item-cell-multi-add-title').text()) {
			// 					console.log('multi-swap', j);
			// 					dis.swapElements(products.eq(j), products.eq(j + 1));
			// 				}
			// 			}
			// 		}
			// 	}
			// });
		}
	};
});
